import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { CandidateService } from '../../../services/candidate.service';
import { ToolService } from '../../../services/tool.service';
import { ICandidate } from '../../../models/ICandidate.model';
import { ICompanyContact } from '../../../models/ICompanyContact.model';
import { IScheduleDay } from '../../../models/IScheduleDay.model';
import { ISaveScheduleDay } from '../../../models/ISaveScheduleDay.model';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'app-request-interview',
    templateUrl: './requestInterview.component.html',
    styleUrls: ['./requestInterview.component.less']
})
export class RequestInterviewComponent implements OnInit {
    @Input() contact: ICompanyContact;
    @Input() candidate: ICandidate;
    @Output() requestSent: EventEmitter<boolean> = new EventEmitter();

    types: any[] = [
        { name: 'Phone', value: 3 },
        { name: 'In-Person', value: 1 },
        { name: 'Video', value: 4 },
    ];

    interviewTypeId = 3;
    requestNote = '';
    impersonating = false;
    origSchedule: IScheduleDay[] = [];
    updatedSchedules: ISaveScheduleDay[] = [];
    deletedSchedules: number[] = [];

    constructor(
        private candidateService: CandidateService,
        private toolsService: ToolService,
        private auth: AuthService
    ) { }

    private getSchedules(updated: ISaveScheduleDay[], deleted: number[]): void {
        const days = ['M', 'T', 'W', 'Th', 'F', 'S', 'Su'];

        this.contact.GroupedSchedules.forEach(function (s) {
            if (s.isDeleted) {
                days.forEach(function (d) {
                    if (s.HasId[d])
                        deleted.push(s.HasId[d]);
                });
            } else {
                days.forEach(function (d) {
                    if (s.HasId[d] && !s.DaySelected[d]) {
                        deleted.push(s.HasId[d]);
                    } else if (s.DaySelected[d]) {
                        const schedule = {
                            ScheduleDay: d,
                            CompanyContactScheduleId: s.HasId[d],
                            ScheduleTimeFromDate: null,
                            ScheduleTimeToDate: null,
                            ScheduleTimeFrom: s.ScheduleTimeFrom,
                            ScheduleTimeTo: s.ScheduleTimeTo,
                            AllDay: s.AllDay
                        }
                        updated.push(schedule);
                    }
                })
            }
        })
    }

    requestInterview(): void {
        if (!this.candidate || !this.contact) return;

        this.getSchedules(this.updatedSchedules, this.deletedSchedules);

        this.candidateService
            .requestInterview(this.contact.CompanyContactId, this.candidate.JobAppId, this.requestNote, this.interviewTypeId, this.updatedSchedules, this.deletedSchedules)
            .then(() => {
                this.requestSent.emit(true);
            });
    }

    cancel(): void {
        this.requestSent.emit(false);
    }

    ngOnInit() {
        this.origSchedule = this.toolsService.clone(this.contact.Schedules);
        this.impersonating = this.auth.getImpersonationData() != null;

        const days = ['M', 'T', 'W', 'Th', 'F', 'S', 'Su'];

        this.contact.GroupedSchedules.map(s => {
            const selected = s.ScheduleDay.split(',')
            const ids = s.CompanyContactScheduleId.split(',')

            s.DaySelected = {}
            s.HasId = {}

            days.map(d => {
                s.DaySelected[d] = selected.includes(d)
                s.HasId[d] = s.DaySelected[d] ? parseInt(ids[selected.indexOf(d)], 10) : null;
            });

            s.AllDay = !s.ScheduleTimeFrom && !s.ScheduleTimeTo
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/common/requestInterview/requestInterview.component.ts